export const nonEmptyString = s => {
  if (!s || !s.length) {
    return emptyString;
  } else {
    return s;
  }
};
export const emptyString = null;